module.exports = __webpack_public_path__ + "img/selected2-min.7ea1b507.png";